export const SUPPORT_BOARD_FEATURE_FLAG = "support_board_feature";
